import { Http, Headers } from "@angular/http";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";
var DocumentoService = /** @class */ (function () {
    function DocumentoService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    DocumentoService.prototype.getDocumento = function () {
        return this._http
            .get("assets/json/pasos.json")
            .pipe(map(function (res) { return res.json(); }));
    };
    DocumentoService.prototype.getUploaders = function () {
        return this._http
            .get("assets/json/documentos.json")
            .pipe(map(function (res) { return res.json(); }));
    };
    DocumentoService.prototype.uploadFile = function (file) {
        var headers = new Headers({
            "Content-type": "application/json",
            Authorization: sessionStorage.getItem("token-domCloud"),
        });
        return this._http
            .post(this.url + "save/archivos", file, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    DocumentoService.prototype.uploadF = function (files, user) {
        var headers = new Headers({
            "Content-Type": "application/json",
        });
        var params = {
            files: files,
            user: user,
        };
        return this._http.post(this.url + "upload/ftp", params, {
            headers: headers,
        });
    };
    DocumentoService.prototype.uploadFilesDBX = function (files, formType) {
        if (formType === void 0) { formType = ""; }
        var formData = new FormData();
        formData.append("formType", formType);
        files.map(function (file) {
            if (!(file == null || file == undefined)) {
                var doExt = file.doc.name.split(".");
                doExt =
                    file.name +
                        "-" +
                        new Date().getTime() +
                        "." +
                        doExt[doExt.length - 1];
                var fil = void 0;
                fil = file.doc;
                formData.append("uploads[]", fil, doExt);
            }
        });
        return this._http
            .post(this.url + "upload/dbx", formData)
            .pipe(map(function (res) { return res.json(); }));
    };
    DocumentoService.prototype.uploadFiles = function (files, formType) {
        if (formType === void 0) { formType = ""; }
        var headers = new Headers({
            "Content-Type": "application/json",
        });
        var formData = new FormData();
        formData.append("formType", formType);
        files.map(function (file) {
            if (!(file == null || file == undefined)) {
                var doExt = file.doc.name.split(".");
                doExt =
                    file.name +
                        "-" +
                        new Date().getTime() +
                        "." +
                        doExt[doExt.length - 1];
                var fil = void 0;
                fil = file.doc;
                formData.append("uploads[]", fil, doExt);
            }
        });
        return this._http
            .post(this.url + "upload/webservice", formData)
            .pipe(map(function (res) { return res.json(); }));
    };
    DocumentoService.prototype.uploadInspeccionDBX = function (files, formType) {
        if (formType === void 0) { formType = ""; }
        console.log("uploadInspeccionDBX()");
        var formData = new FormData();
        formData.append("formType", formType);
        files.map(function (file) {
            console.log(file, "file");
            if (file !== null || file !== undefined) {
                var doExt = file.doc.name.split(".");
                doExt =
                    file.name +
                        "-" +
                        new Date().getTime() +
                        "." +
                        doExt[doExt.length - 1];
                var fil = void 0;
                fil = file.doc;
                formData.append("uploads[]", fil, doExt);
            }
        });
        console.log("formData", formData);
        return this._http.post(this.url + "upload/inspeccion/dbx", formData)
            .pipe(map(function (response) { return response.json(); }));
        //console.log('object');
    };
    DocumentoService.prototype.uploadBNUPDBX = function (files, formType) {
        if (formType === void 0) { formType = ""; }
        console.log("uploadBNUPDBX()");
        var formData = new FormData();
        formData.append("formType", formType);
        files.map(function (file) {
            console.log(file, "param File");
            if (file !== null || file !== undefined) {
                var doExt = file.doc.name.split(".");
                doExt =
                    file.name +
                        "-" +
                        new Date().getTime() +
                        "." +
                        doExt[doExt.length - 1];
                var fil = void 0;
                fil = file.doc;
                formData.append("uploads[]", fil, doExt);
            }
            console.log("81", file, formData);
        });
        // console.log("object");
        return this._http.post(this.url + "upload/bnup/dbx", formData)
            .pipe(map(function (response) { return response.json(); }));
        //console.log('object');
    };
    return DocumentoService;
}());
export { DocumentoService };
